import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "reactstrap";
import qrCode from "../../assets/img/Nextpak 2.png";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFamilyQrCodes } from "../../store/actions/MomentosActions";

const FamilyQRcodes = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [Loader, setLoader] = useState(-1);
    const { user } = useSelector((state) => state.authUser);
    const { familyCodes, loading } = useSelector((state) => state.momentos);

    const convertDate = (createdAt) => {
        const date = new Date(
            createdAt?.seconds * 1000 + createdAt?.nanoseconds / 1e6
        );
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        dispatch(getFamilyQrCodes(user?.id));
    }, []);

    const handleDownload = async (item, index) => {
        setLoader(index);
        try {
            const response = await fetch(
                `cors-platform-2-44c3877bb9f7.herokuapp.com/${item.url}`
            );
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", `${item?.userName}_qr-code.png`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoader(-1);
        } catch (error) {
            setLoader(-1);
            console.error("Error downloading image:", error);
        }
    };

    return (
        <Container fluid>
            <Row className="justify-content-center  mx-4 py-3">
                <h3>QR-Codes From Friends and Family </h3>
            </Row>
            {loading ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <Container>
                    <Row className="justify-content-end my-3 mr-1">
                        <Button
                            onClick={() => history.push("/main/qr-request")}
                            color="primary"
                        >
                            Request QR Code
                        </Button>
                    </Row>
                    {familyCodes?.map((item, index) => {
                        return (
                            <Card className="submit_card py-4 mb-3">
                                <Row>
                                    <Col className="col-3 d-flex flex-column justify-content-center align-items-center">
                                        <img
                                            src={item.url}
                                            className="w-50"
                                            alt="qr-code"
                                        />
                                        <Button
                                            className="submit_card__download mt-2"
                                            disabled={index == Loader}
                                            onClick={() =>
                                                handleDownload(item, index)
                                            }
                                        >
                                            {index == Loader ? (
                                                <Spinner
                                                    size="sm"
                                                    className="mx-4"
                                                />
                                            ) : (
                                                "Download"
                                            )}
                                        </Button>
                                    </Col>
                                    <Col className="col-8 d-flex flex-column justify-content-end ">
                                        <div className="d-flex justify-content-around submit_card__details">
                                            <p>{item?.userName}</p>
                                            <p>
                                                {convertDate(item?.createdAt)}
                                            </p>
                                        </div>
                                        <div className="d-flex justify-content-around mt-2">
                                            <p>
                                                <strong>Submitted By</strong>
                                            </p>
                                            <p>
                                                <strong>Date</strong>
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>
                        );
                    })}
                </Container>
            )}
        </Container>
    );
};

export default FamilyQRcodes;
